/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VorlagenProblemTypes = {
    VorlageDokumentIstEntfernt: 'VorlageDokumentIstEntfernt',
    VorlageDokumentNichtGefunden: 'VorlageDokumentNichtGefunden',
    VorlageDokumentKannNichtBearbeiten: 'VorlageDokumentKannNichtBearbeiten',
    VorlageChecklisteNichtGefunden: 'VorlageChecklisteNichtGefunden',
    VorlageChecklisteGeloescht: 'VorlageChecklisteGeloescht',
    VorlageAufgabeNichtGefunden: 'VorlageAufgabeNichtGefunden',
    VorlageAufgabeGeloescht: 'VorlageAufgabeGeloescht',
    DisplaysteuerungKeinAdminOderFunktionsbereichAdmin: 'DisplaysteuerungKeinAdminOderFunktionsbereichAdmin',
    VorlageBenutzerDarfDokumentNichtBearbeiten: 'VorlageBenutzerDarfDokumentNichtBearbeiten',
    VorlageBenutzerDarfDokumentNichtVerwalten: 'VorlageBenutzerDarfDokumentNichtVerwalten',
    VorlageDokumentIdFehlt: 'VorlageDokumentIdFehlt',
    VorlageAufgabeIdFehlt: 'VorlageAufgabeIdFehlt',
    VorlageChecklisteIdFehlt: 'VorlageChecklisteIdFehlt',
    VorlageBenutzerKeinVorlagenAdmin: 'VorlageBenutzerKeinVorlagenAdmin'
} as const;
export type VorlagenProblemTypes = typeof VorlagenProblemTypes[keyof typeof VorlagenProblemTypes];

